import { Injectable } from '@angular/core';
import {ErrorHandlingModel} from './error-handling.model';
import {ResponseError} from './response-error.model';
import {Observable, throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

  constructor() { }

  handleErrors(error: any): Observable<never> {

    const errorConverted = (error as unknown as ResponseError);

    // console.log('error in error handling', error, errorConverted, errorConverted.statusText);

    let err = new ErrorHandlingModel();
    err.message = errorConverted.error?.message;
    err.data = errorConverted.error?.data;

    if (errorConverted.statusText === 'Unknown Error') {
      errorConverted.message = undefined;
    }

    if (err.message === undefined && errorConverted.message !== undefined) {
      err.message = errorConverted.message;
    } else if (err.message === undefined) {
      err.message = 'Ha ocurrido un error en el sistema, favor intentar más tarde.';
    }

    if (errorConverted['errorsInHTML'] === undefined) {

      const errors = errorConverted.error?.errors;

      err.errorsInHTML = '';
      if (errors !== undefined && errors !== null) {
        err.errors = [];
        err.errorsInHTML = '<ul>';
        for (const errorKey in errors) {

          for (const key in errors[errorKey]) {
            err.errors.push(errors[errorKey][key] as string);
            err.errorsInHTML += '<li>' + (errors[errorKey][key] as string) + '</li>';
          }
        }

        err.errorsInHTML += '</ul>';
      }
    } else {
      err = (errorConverted as unknown as ErrorHandlingModel);
    }

    return throwError(err);
  }
}
